/**
 * The batch-sign run's vocabulary, declared here because the app-side run
 * record and the headless sequencer both read it and neither owns it.
 *
 * An approval PATCH submits to eCW server-side (ml-scribe #19636), so `sent`
 * means eCW confirmed the refill and `notSigned` (shown as "Not sent") means
 * the submission failed closed.
 *
 * `skipped` IS NOT A RESULT FOR THE SCRIPT, it is a result for the ATTEMPT:
 * the writer refused because the request was already settled or another write
 * was in flight. It is recorded WITHOUT advancing the cursor, so the row keeps
 * its turn and a resume retries it — which is why the board needs a word for
 * it rather than leaving the halted row reading `Queued` (AGE-2370 review).
 *
 * No value here claims the doctor signed; that happens later in eCW.
 */
export type RefillBatchRowState = 'sent' | 'notSigned' | 'skipped';

export const REFILL_BATCH_ROW_STATES: readonly RefillBatchRowState[] = [
  'sent',
  'notSigned',
  'skipped',
];

/** The states that mean this runner wrote something. `skipped` did not. */
export const isRefillBatchWrite = (state: RefillBatchRowState): boolean =>
  state !== 'skipped';
